import { useState } from 'react';
import { Button, FieldError, Input, Label, TextField } from '@heroui/react';

import AuthLayout, { AuthLink } from '../components/common/AuthLayout';
import Notice from '../components/common/Notice';
import userService from '../services/auth.service';
import { messageOf } from '../i18n/el';

// Πρώτο βήμα της ανάκτησης πρόσβασης: αίτημα συνδέσμου επαναφοράς (ΛΑ-01).
//
// **Η οθόνη υπάρχει και η διαδρομή του API όχι.** Το `/api/auth/forgot` δεν έχει
// υλοποιηθεί, οπότε η κλήση απορρίπτεται με `501` και το μήνυμα εμφανίζεται
// αυτούσιο. Παρακολουθείται ως ΛΑ-01 στον πίνακα κάλυψης.

export default function ResetPasswordPage() {
    const [email, setEmail] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [isPending, setIsPending] = useState(false);
    const [error, setError] = useState('');
    const [successMsg, setSuccessMsg] = useState('');

    const missingEmail = submitted && !email;

    function handleSubmit(event) {
        event.preventDefault();
        setSubmitted(true);
        setError('');

        if (!email) return;

        setIsPending(true);
        // ⚠ **Το ίδιο μήνυμα, ό,τι κι αν συμβεί.** Ο εξυπηρετητής απαντά
        // ταυτόσημα για υπαρκτή και ανύπαρκτη διεύθυνση· αν η οθόνη έλεγε
        // «στάλθηκε» μόνο στη μία περίπτωση, θα ξανάφτιαχνε την απαρίθμηση
        // λογαριασμών στον πελάτη.
        userService.resetPassword(email).then(
            () => {
                setSuccessMsg(
                    'Στάλθηκε μήνυμα στη διεύθυνσή σας με σύνδεσμο επαναφοράς. Ο σύνδεσμος λήγει σε 30 λεπτά.'
                );
                setIsPending(false);
            },
            // **Η αποτυχία εμφανίζεται αυτούσια, και είναι πλέον πραγματική
            // αποτυχία**: υπερβολικά συχνά αιτήματα (429) ή μη διαμορφωμένη
            // αποστολή (503). Η οθόνη δεν δείχνει επιτυχία για κάτι που δεν
            // έγινε — και δεν δείχνει ποτέ «δεν βρέθηκε λογαριασμός», γιατί ο
            // εξυπηρετητής δεν το λέει ποτέ.
            (apiError) => {
                setError(messageOf(apiError));
                setIsPending(false);
            }
        );
    }

    return (
        <AuthLayout
            title="Επαναφορά κωδικού"
            subtitle="Δώστε τη διεύθυνσή σας και θα σας στείλουμε σύνδεσμο επαναφοράς"
            footer={<AuthLink to="/login">Επιστροφή στη σύνδεση</AuthLink>}
        >
            {error && <Notice status="danger" title="Η επαναφορά δεν είναι διαθέσιμη">{error}</Notice>}
            {successMsg && (
                <Notice status="success" title="Το μήνυμα στάλθηκε" onDismiss={() => setSuccessMsg('')}>
                    {successMsg}
                </Notice>
            )}

            <form onSubmit={handleSubmit} className="flex flex-col gap-4" noValidate>
                <TextField
                    name="email"
                    type="email"
                    value={email}
                    onChange={setEmail}
                    isInvalid={missingEmail}
                    autoComplete="email"
                >
                    <Label>Διεύθυνση ηλεκτρονικού ταχυδρομείου</Label>
                    <Input placeholder="name@example.gr" />
                    <FieldError>Η διεύθυνση είναι υποχρεωτική</FieldError>
                </TextField>

                <Button type="submit" isPending={isPending} className="mt-2">
                    Αποστολή συνδέσμου
                </Button>
            </form>
        </AuthLayout>
    );
}
